import React, { useState, useEffect } from "react";
import NuovaOrchestra from "../imgs/Nuova orchestra.jpeg";
import { FaUsers, FaBullseye, FaLightbulb, FaMusic } from "react-icons/fa";
import { GiNewspaper } from "react-icons/gi";
import { useForm, ValidationError } from "@formspree/react";
import loc5x1000 from "../imgs/Locandine/Locandina5x1000.jpeg";

const Home = () => {
  function importAll(r) {
    return r.keys().map(r);
  }

  const images = importAll(
    require.context("../imgs/Galleria", false, /\.(png|jpe?g|webp)$/),
  );

  const [currentIndex, setCurrentIndex] = useState(() =>
    Math.floor(Math.random() * images.length),
  );
  const [isAnimating, setIsAnimating] = useState(false);
  const [fullScreenImage, setFullScreenImage] = useState(null);

  const [state, handleSubmit] = useForm("xpwkaddj");

  useEffect(() => {
    let timeoutId;

    const intervalId = setInterval(() => {
      setIsAnimating(true);
      timeoutId = setTimeout(() => {
        if (images.length > 0) {
          setCurrentIndex((prev) => {
            if (images.length <= 1) return prev;

            let next;
            do {
              next = Math.floor(Math.random() * images.length);
            } while (next === prev);

            return next;
          });
        }
        setIsAnimating(false);
      }, 800);
    }, 4000);

    return () => {
      clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [images.length]);

  const handleImageClick = (img) => setFullScreenImage(img);
  const closeImage = () => setFullScreenImage(null);

  return (
    <div className="flex flex-col items-center bg-gradient-to-r from-white to-amber-50 min-h-screen text-gray-800 overflow-hidden">
      {/* Titolo */}
      <h1 className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        NEWS
      </h1>
      <GiNewspaper className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />
      {/* Carosello */}
      <div className=" relative w-11/12 md:w-3/4 lg:w-2/3  h-80 md:h-[28rem]  rounded-3xl  overflow-hidden  shadow-[0_8px_25px_rgba(0,0,0,0.15)  mt-5 mb-10  bg-gradient-to-br from-white via-amber-50/40 to-amber-100/3  border border-white/6  backdrop-blur-l  transition-all duration-50  hover:shadow-[0_12px_35px_rgba(0,0,0,0.20)  hover:scale-[1.01]">
        {/* Immagine */}
        <img
          src={images[currentIndex]}
          alt="Galleria Milarte"
          className={`absolute inset-0 w-full h-full object-contain transition-all duration-1000 ease-in-out ${
            isAnimating ? "opacity-0 scale-105" : "opacity-100 scale-100"
          }`}
          onClick={() => handleImageClick(images[currentIndex])}
        />

        {/* Vignettatura molto più leggera */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-black/10 pointer-events-none" />

        {/* Logo */}
        <img
          src={NuovaOrchestra}
          alt="Logo Nuova Orchestra"
          className="absolute top-4 left-4 w-20 md:w-28 opacity-95 drop-shadow-md"
        />

        {/* Cornice chiara */}
        <div className="absolute inset-0 rounded-3xl border border-white/40 pointer-events-none" />
      </div>

      {/* Citazione */}
      <div className="bg-white/60 backdrop-blur-md rounded-2xl shadow-md p-8 w-11/12 md:w-3/4 lg:w-2/3 text-center transition-all hover:shadow-xl">
        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
          NUOVA MILANO
        </h2>
        <p className="text-gray-700 italic leading-relaxed">
          “Una scatola sono di cerini, i musicisti mentre stanno insieme, pronti
          a incendiarsi per spiccare il volo. Saranno un palloncino della fiera
          come quelli sfuggiti dalle mani che sembrano uno stormo cittadino o un
          labirinto in note musicali che anche a una carriola dà le ali.”
        </p>
        <p className="mt-4 text-sm md:text-base font-semibold text-gray-700">
          Guido Oldani – Ideatore del Realismo Terminale (inedito)
        </p>
      </div>

      {/* Locandina */}
      <div className="md:w-1/4 xs:w-2/4 mt-10 mb-12 transform hover:scale-[1.03] transition-transform duration-500 cursor-pointer">
        <img
          src={loc5x1000}
          alt="Locandina Concerto"
          className="w-full rounded-2xl shadow-lg"
          onClick={() => handleImageClick(loc5x1000)}
        />
      </div>

      {/* Testo descrittivo */}
      <div className="w-11/12 md:w-3/4 lg:w-2/3 mb-16 text-center space-y-10">
        <p className="text-lg leading-relaxed">
          <FaUsers className="inline text-red-600 text-2xl mr-2" />
          MilArte è un'Associazione di Promozione Sociale dedicata alla musica,
          fondata nel 2023 con l'obiettivo di diffondere la passione musicale e
          creare un impatto positivo nella comunità. La visione di{" "}
          <a
            href="https://www.giuseppedinardo.it/"
            className="text-red-600 font-semibold hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Giuseppe Dinardo
          </a>{" "}
          ha guidato la nascita dell’associazione, consolidando la sua presenza
          nel panorama musicale milanese.
        </p>

        <p className="text-lg leading-relaxed">
          <FaBullseye className="inline text-amber-600 text-2xl mr-2" />
          Gli obiettivi principali includono la proposta di concerti, eventi e
          iniziative culturali per rendere la musica accessibile e viva. MilArte
          lavora per creare esperienze musicali che arricchiscano la vita di chi
          ascolta e di chi suona.
        </p>

        <p className="text-lg leading-relaxed">
          <FaLightbulb className="inline text-yellow-500 text-2xl mr-2" />
          In programma anche visite e concerti nelle scuole per condividere la
          magia della musica fatta con mani umane e nutrire interiormente i
          giovani ascoltatori.
        </p>
      </div>

      {/* Modal fullscreen */}
      {fullScreenImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={closeImage}
        >
          <img
            src={fullScreenImage}
            alt="Full screen"
            className="max-w-[90vw] max-h-[90vh] rounded-2xl shadow-2xl"
          />
        </div>
      )}

      {/* --- SEZIONE NEWSLETTER --- */}
      <div className="w-full flex flex-col items-center text-center mb-10 z-10 px-11">
        <h2 className="text-2xl font-bold text-red-600 mb-3">
          Iscriviti alla Newsletter
        </h2>

        <p className="text-gray-700 max-w-xl mb-4">
          Rimani aggiornato su corsi, eventi e iniziative. <br />
          <span className="text-red-600 font-semibold">
            Iscrivendoti oggi riceverai anche un piccolo gadget omaggio!
          </span>
        </p>

        {state.succeeded ? (
          <p className="text-green-600 text-lg font-semibold">
            ✅ Grazie per aver inviato la tua iscrizione! Ti contatteremo
            presto.
            <br />
            🎁 E non dimenticare: un gadget omaggio ti aspetta!
          </p>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full max-w-4xl text-left"
          >
            <input type="hidden" name="_subject" value="Milarte Newsletter" />

            <div className="flex flex-col sm:col-span-2">
              <label
                htmlFor="Email"
                className="text-sm font-medium text-gray-700"
              >
                Email
              </label>
              <input
                id="Email"
                name="Email"
                type="Email"
                required
                placeholder="Inserisci la tua email"
                className="mt-1 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
              />
            </div>

            {/* --- BOTTONE --- */}
            <div className="col-span-full flex justify-center mt-4">
              <button
                type="submit"
                disabled={state.submitting}
                className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition disabled:opacity-50 font-semibold"
              >
                Invia Iscrizione
              </button>
            </div>
          </form>
        )}
      </div>
      {/* --- FINE SEZIONE NEWSLETTER --- */}
    </div>
  );
};

export default Home;
